import chatModule from '../chatModule';

const notificationsName = {
    ChatNotifications: "ChatNotifications",
    FriendshipNotifications: "FriendshipNotifications",
    PresenceNotifications: "PresenceNotifications",
    ChatPrivacySettingNotifications: "ChatPrivacySettingNotifications",
    PresenceBulkNotifications: "PresenceBulkNotifications"
};

chatModule.constant("notificationsName", notificationsName);

export default notificationsName;